@use 'node_modules/@design/bapf-pattern-library/source/sass/settings/dpl-variables';

// DPL3 Pattern
@use '@design/bapf-pattern-library/source/sass/patterns/form';
@use '@design/bapf-pattern-library/source/sass/patterns/modal';
@use '@design/bapf-pattern-library/source/sass/patterns/alert';

* {
  font-family: inherit !important;
}

.feedback-component-text {
  display: block;
  position: relative;
  margin-bottom: 4px;
  color: #595959;
  font-family: 'Roboto Condensed', 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.2;
}

#success-message.alert {
  border: 0 !important;
  background: none !important;
}

.weight-700 {
  font-weight: 700 !important;
}
